export default {
  stockData: [],
  pricingTables: [],
  savedStock: [],
  stockLoaded: false
}
